import SectionHeading from '@/pages/home/components/SectionHeading';
import useScrollReveal from '@/hooks/useScrollReveal';
import { homeResourceTypes } from '@/mocks/home';

export default function ResourceTypes() {
  const { ref, visible } = useScrollReveal();

  return (
    <section id="types" className="w-full bg-background-50 py-16 md:py-24 scroll-mt-24">
      <div ref={ref} className={`w-full px-4 md:px-8 nh-reveal ${visible ? 'nh-in' : ''}`}>
        <SectionHeading
          align="center"
          kicker="素材形态"
          title="三种素材形态，各有各的看头"
          desc="同一件事，原视频、录屏和原始截图能提供的信息并不相同。归档时会按形态分类，方便你按需查找。"
        />

        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {homeResourceTypes.map((type) => (
            <article key={type.id} className="flex flex-col rounded-lg bg-background-100 border border-background-200 p-6 md:p-7">
              <span className="w-14 h-14 flex items-center justify-center rounded-md bg-primary-100 text-primary-600">
                <i className={`${type.icon} text-2xl`}></i>
              </span>
              <h3 className="mt-5 font-heading text-lg md:text-xl font-bold text-foreground-950">{type.name}</h3>
              <p className="mt-3 text-sm leading-relaxed text-foreground-600">{type.desc}</p>
              <ul className="mt-5 pt-5 border-t border-background-300 flex flex-col gap-2.5">
                {type.points.map((point) => (
                  <li key={point} className="flex items-center gap-2 text-sm text-foreground-700">
                    <i className="ri-checkbox-circle-line text-accent-600"></i>
                    {point}
                  </li>
                ))}
              </ul>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}